import { API } from 'common/constants/api-urls';
import { ACTIVITY_TYPES } from '../../../state/state.utils';
import { metricNames } from '@linearb/linjs-common';

export const mapActivityTypeToEntityKey = {
  [ACTIVITY_TYPES.BRANCHES]: 'branch_id',
  [ACTIVITY_TYPES.PRS]: 'pull_request_id',
  [ACTIVITY_TYPES.RELEASE_ID]: 'release_id'
};

export const mapActivityTypeToEntitiesUrl = {
  [ACTIVITY_TYPES.BRANCHES]: API.BRANCHES_RAW_V1,
  [ACTIVITY_TYPES.PRS]: API.PRS_RAW_V1
};

export const entitesAdditionalColumns = {
  [ACTIVITY_TYPES.BRANCHES]: ['stats'],
  [ACTIVITY_TYPES.PRS]: []
};
export const mapMetricNameToYAxisMetric = {
  [metricNames.PR_MERGED]: 'PR size',
  [metricNames.PR_MERGED_WITHOUT_REVIEW]: 'PR size',
  [metricNames.PR_NEW]: 'PR size',
  [metricNames.REVIEW_DEPTH]: 'Total comments'
};
